'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { hasOverlayHistoryEntry } from '@/hooks/useOverlayHistory';
import { useHistoryStore } from '@/stores/HistoryStore/useHistoryStore';
import { useKakaobankExitStore } from '@/stores/KakaobankExitStore';
import { closeResponsiveDialog } from '@/stores/ResponsiveDialogStore';

//* 브릿지에서 방향이 반대인 유일한 함수다 — 카뱅 앱이 안드로이드 back에서 이 전역을 호출한다
export const KakaobankBackController = () => {
  const $ = _c(3);
  const router = useCustomRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      window.onBackPressed = () => {
        if (closeResponsiveDialog()) {
          return;
        }
        if (!hasOverlayHistoryEntry() && useHistoryStore.getState().historyIndex < 1 && DONATION_ROUTES.HOME.isMatchPathname(location.pathname)) {
          useKakaobankExitStore.getState().openExitConfirm();
          return;
        }
        router.back(DONATION_ROUTES.HOME.pathname);
      };
      return _temp;
    };
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
};
function _temp() {
  Reflect.deleteProperty(window, "onBackPressed");
}